import { useStoreContext } from "../context";
import { Actions } from "../context/reducer";
import { handleLogout } from "../backend/auth";
import { removeAuthCookies } from "../helpers";
import { useSWRConfig } from "swr";
import { useRouter } from "next/router";

const useLogout = () => {
  const { dispatch } = useStoreContext();
  const { mutate } = useSWRConfig();
  const router = useRouter();
  const logout = async (hard = false) => {
    if (hard) {
      mutate(() => true, undefined, false);
      localStorage.clear();
      removeAuthCookies()
        .then(async () => {
          await handleLogout();
          dispatch({ type: Actions.LOGOUT });
        })
        .catch(() => dispatch({ type: Actions.LOGOUT }));
      window.location.replace("/login");
    } else {
      router.replace("/logout");
    }
  };
  return logout;
};

export default useLogout;
